import { render, staticRenderFns } from "./modelinfo.vue?vue&type=template&id=c0582cd8"
import script from "./modelinfo.vue?vue&type=script&lang=js"
export * from "./modelinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports